import { AbstractControl, FormControl } from '@angular/forms';
import { IFormBuilder } from '../IFormBuilder';
import { GenericBaryFormGroup, IGenericBaryFormGroup } from '../GenericBaryFormGroup';
import { BaryFormFactoryService } from '../../../services/bary-form-factory.service';

export type AssociationControls = { [key: string]: AbstractControl } & {
  companyName: FormControl;
  siret: FormControl;
  vatNumber: FormControl;
  companyLegalStatus: FormControl;
};

interface IAssociationFormBuilder<T> extends IFormBuilder<T> {
  init(): IAssociationFormBuilder<T>;

  build(): IGenericBaryFormGroup<T>;
}

export class AssociationFormBuilder implements IAssociationFormBuilder<AssociationControls> {
  private formName = 'associationForm';
  private controls!: AssociationControls;

  constructor(private bcf: BaryFormFactoryService) {}

  init(): AssociationFormBuilder {
    this.controls = this.bcf.makeAssociationControls();
    return this;
  }

  build(): IGenericBaryFormGroup<AssociationControls> {
    return new GenericBaryFormGroup(this.formName, this.controls);
  }
}
